export default __webpack_public_path__ + "static/media/game-info.1d3e3b2d.pdf";